import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Form, Card, Dropdown, Modal, Toast, ToastContainer } from "react-bootstrap";
import Sidebar from "../common/Sidebar"; // Assuming Sidebar is here based on previous files
import { FiGrid, FiClock, FiDownload, FiCalendar, FiChevronDown, FiSave, FiLayout, FiTarget, FiUsers, FiUserCheck, FiMapPin, FiBriefcase, FiCheckSquare, FiPackage, FiTruck, FiUser, FiXCircle } from "react-icons/fi";
import { BsGrid1X2, BsClockHistory, BsBuilding, BsDoorOpen } from "react-icons/bs";
import CommonDropdown from "../common/common_dropDown";
import DateRangePicker from "../common/dateRange";
import { transportReportApi, saveTemplateApi, getTemplatesApi, getTemplateByIdApi, getReportTypesApi, downloadBase64File, getquickreportApi, exportquickApi } from "./report-api";
import LoaderModal from "../common/loader";
import { format } from "date-fns";
//svgs
import report from "../../assets/svg/report.svg";
import che_lis from "../../assets/svg/che_lis.svg";
import coin from "../../assets/svg/coin.svg";
import company from "../../assets/svg/company.svg";
import dept from "../../assets/svg/dept.svg";
import drive from "../../assets/svg/drive.svg";
import gate from "../../assets/svg/gate.svg";
import lov_rep from "../../assets/svg/loc_rep.svg";
import meeting from "../../assets/svg/meeting.svg";
import monthly from "../../assets/svg/monthly.svg";
import org from "../../assets/svg/org.svg";
import pop from "../../assets/svg/pop.svg";
import reg from "../../assets/svg/reg.svg";
import time from "../../assets/svg/time.svg";

const Report = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const [activeTab, setActiveTab] = useState("Customized");
  const [loading, setLoading] = useState(false);

  // Filter States
  const [type, setType] = useState({ value: "Stop", label: "Stop" });
  const [customer, setCustomer] = useState(null);
  const [product, setProduct] = useState(null);
  const [vehicle, setVehicle] = useState(null);
  const [driver, setDriver] = useState(null);
  const [address, setAddress] = useState(null);
  const [status, setStatus] = useState(null);
  const [milestone, setMilestone] = useState(null);
  const [stop, setStop] = useState(null);
  const [customizedDateRange, setCustomizedDateRange] = useState({ start: null, end: null });
  const [quickDateRange, setQuickDateRange] = useState({ start: null, end: null });

  // Template States
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success",
  });
  const [quickReportList, setQuickReportList] = useState([]);
  const [loadingReportId, setLoadingReportId] = useState(null); // Track which quick report is loading

  // Ref to track when we're loading a template (to prevent useEffect from clearing fields)
  const isLoadingTemplate = useRef(false);

  const showSnackbar = (message, variant = "success") => {
    setToast({ show: true, message, variant });
  };

  const handleCustomizedDateChange = ({ start, end }) => {
    console.log("Customized Report - Selected Start:", start);
    console.log("Customized Report - Selected End:", end);
    setCustomizedDateRange({ start, end });
  };

  const handleQuickDateChange = ({ start, end }) => {
    console.log("Quick Report - Selected Start:", start);
    console.log("Quick Report - Selected End:", end);
    setQuickDateRange({ start, end });
  };
  useEffect(() => {
    fetchTemplates();
    getQuickReport();
  }, []);

  // Clear ALL fields when type changes between Stop and Trip (but not when loading a template)
  useEffect(() => {
    if (type?.value && !isLoadingTemplate.current) {
      setCustomer(null);
      setProduct(null);
      setVehicle(null);
      setDriver(null);
      setAddress(null);
      setStatus(null);
      setMilestone(null);
      setStop(null);
    }
  }, [type?.value]);

  const fetchTemplates = async () => {
    const response = await getTemplatesApi();
    if (response && response.data && response.data.success) {
      setTemplates(response.data.suggestionlist);
    }
  };

  const handleTemplateSelect = async (templateId) => {
    setLoading(true);
    isLoadingTemplate.current = true; // Prevent clearing on type change
    try {
      const response = await getTemplateByIdApi(templateId);
      if (response && response.data && response.data.success) {
        const data = response.data.template;

        setType(data.type ? { label: data.type, value: data.type } : null); // Type is likely a string in DB
        setCustomer(data.customers && data.customers.length > 0 ? data.customers[0] : null);
        setProduct(data.products && data.products.length > 0 ? data.products[0] : null);
        setVehicle(data.vehicles && data.vehicles.length > 0 ? data.vehicles[0] : null);
        setDriver(data.drivers && data.drivers.length > 0 ? data.drivers[0] : null);
        setAddress(data.locations && data.locations.length > 0 ? data.locations[0] : null);
        setStatus(data.status && data.status.length > 0 ? data.status[0] : null);
        setMilestone(data.milestones && data.milestones.length > 0 ? data.milestones[0] : null);
        setStop(data.stops && data.stops.length > 0 ? data.stops[0] : null);
        if (data.from_date && data.to_date) {
          setCustomizedDateRange({
            start: new Date(data.from_date),
            end: new Date(data.to_date),
          });
        } else if (data.from_date) {
          // Handle case where only from_date exists (like in your example)
          setCustomizedDateRange({
            start: new Date(data.from_date),
            end: null,
          });
        } else {
          setCustomizedDateRange({ start: null, end: null });
        }
      }
    } catch (error) {
      console.error("Error loading template:", error);
    } finally {
      setLoading(false);
      // Reset the flag after a short delay to allow all state updates to complete
      setTimeout(() => {
        isLoadingTemplate.current = false;
      }, 100);
    }
  };

  const handleReset = () => {
    setType({ value: "Stop", label: "Stop" });
    setCustomer(null);
    setProduct(null);
    setVehicle(null);
    setDriver(null);
    setAddress(null);
    setStatus(null);
    setMilestone(null);
    setStop(null);
    setCustomizedDateRange({ start: null, end: null });
    setSelectedTemplate(null);
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const payload = {
        type: type?.value,
        customers: customer ? [customer.value] : [],
        products: product ? [product.value] : [],
        vehicles: vehicle ? [vehicle.value] : [],
        drivers: driver ? [driver.value] : [],
        locations: address ? [address.value] : [],
        status: status ? [status.value] : [],
        milestones: milestone ? [milestone.value] : [],
        stops: stop ? [stop.value] : [],
        from_date: customizedDateRange.start ? format(customizedDateRange.start, "yyyy-MM-dd") : null,
        to_date: customizedDateRange.end ? format(customizedDateRange.end, "yyyy-MM-dd") : null,
      };

      console.log("Customized Report Payload:", payload);
      const response = await transportReportApi(payload);
      console.log("Customized Report Response:", response);

      if (response && response.data) {
        if (response.data.success === true || response.data.success === "true") {
          if (response.data.base64) {
            downloadBase64File(response.data.base64, response.data.file_name || "report.xlsx");
            showSnackbar("Report downloaded successfully!", "success");
          } else if (response.data.url) {
            const link = document.createElement("a");
            link.href = response.data.url;
            link.download = response.data.file_name || "report.xlsx";
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            showSnackbar("Report downloaded successfully!", "success");
          } else {
            showSnackbar(response.data.message || "Report generated but no file returned", "warning");
          }
        } else {
          showSnackbar(response.data.message || "Failed to generate report", "danger");
        }
      } else {
        showSnackbar("No response from server", "danger");
      }
    } catch (error) {
      console.error("Error exporting report:", error);
      showSnackbar(error?.response?.data?.message || "An error occurred while exporting.", "danger");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveTemplate = async () => {
    if (!templateName) return;
    setLoading(true);
    try {
      const payload = {
        template_name: templateName,
        type: type?.value,
        customers: customer ? [customer.value] : [],
        products: product ? [product.value] : [],
        vehicles: vehicle ? [vehicle.value] : [],
        drivers: driver ? [driver.value] : [],
        locations: address ? [address.value] : [],
        status: status ? [status.value] : [],
        milestones: milestone ? [milestone.value] : [],
        stops: stop ? [stop.value] : [],
        from_date: customizedDateRange.start ? format(customizedDateRange.start, "yyyy-MM-dd") : null,
        to_date: customizedDateRange.end ? format(customizedDateRange.end, "yyyy-MM-dd") : null,
      };
      const response = await saveTemplateApi(payload);
      if (response && response.data && response.data.status) {
        // Note: PHP returns 'status' => true
        showSnackbar("Template saved successfully", "success");
        setShowSaveModal(false);
        setTemplateName("");
        fetchTemplates();
      } else {
        showSnackbar(response?.data?.message || "Failed to save template", "danger");
      }
    } catch (error) {
      console.error("Error saving template:", error);
    } finally {
      setLoading(false);
    }
  };

  const getQuickReport = async () => {
    try {
      const response = await getquickreportApi();
      if (response && response.success === true) {
        setQuickReportList(response.suggestionlist);
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  const exportQuickGet = async (option) => {
    setLoadingReportId(option.value); // Set loading for this specific report
    try {
      const formattedFromDate = quickDateRange.start ? format(quickDateRange.start, "yyyy-MM-dd") : null;
      const formattedToDate = quickDateRange.end ? format(quickDateRange.end, "yyyy-MM-dd") : null;

      const response = await exportquickApi(option.value, formattedFromDate, formattedToDate);

      if (response && response.data && response.data.success) {
        if (response.data.base64) {
          downloadBase64File(response.data.base64, response.data.file_name || "report.xlsx");
          showSnackbar("Report downloaded successfully!", "success");
        } else {
          showSnackbar(response.data.message || "Report generated successfully!", "success");
        }
      } else {
        showSnackbar(response?.data?.message || "Failed to generate report", "danger");
      }
    } catch (error) {
      console.error("Error exporting quick report:", error);
      showSnackbar("An error occurred while exporting.", "danger");
    } finally {
      setLoadingReportId(null); // Clear loading state
    }
  };

  // Helper to map API keys/labels to icons if needed, or use a default
  const getIconForReport = (label) => {
    // Simple mapping based on label keywords or exact matches
    const lowerLabel = label.toLowerCase();
    if (lowerLabel.includes("monthly")) return <img src={monthly} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("weekly")) return <img src={monthly} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("visit")) return <img src={coin} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("visitor")) return <img src={meeting} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("meeting")) return <img src={meeting} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("gate")) return <img src={gate} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("location")) return <img src={lov_rep} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("department")) return <img src={dept} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("organization")) return <img src={company} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("checklist")) return <img src={che_lis} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("rejected")) return <img src={org} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("time")) return <img src={time} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("courier")) return <img src={coin} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("vehicle")) return <img src={pop} style={{ width: "20px", height: "20px" }} />;
    if (lowerLabel.includes("driver")) return <img src={drive} style={{ width: "20px", height: "20px" }} />;
    return <img src={reg} style={{ width: "20px", height: "20px" }} />;
  };

  const renderFilters = () => {
    // Get lowercase type value for case-insensitive comparison
    const typeValue = type?.value?.toLowerCase();

    // Default filters if no type selected or type doesn't match specific cases
    let filters = (
      <>
        <Col md={3}>
          <Form.Group>
            <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
              Customer
            </Form.Label>
            <CommonDropdown key={`customer-${typeValue}`} apiUrl={`${apiUrl}customer/autosuggestion`} placeholder="Select" value={customer} onSelect={setCustomer} searchView={true} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
              Product
            </Form.Label>
            <CommonDropdown key={`product-${typeValue}`} apiUrl={`${apiUrl}item/autosuggestion`} placeholder="Select" value={product} onSelect={setProduct} searchView={true} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
              Vehicle
            </Form.Label>
            <CommonDropdown key={`vehicle-${typeValue}`} apiUrl={`${apiUrl}vehicle/autosuggestion`} placeholder="Select" value={vehicle} onSelect={setVehicle} searchView={true} />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group>
            <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
              Driver
            </Form.Label>
            <CommonDropdown key={`driver-${typeValue}`} apiUrl={`${adminUrl}get_driver`} placeholder="Select" value={driver} onSelect={setDriver} searchView={true} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
              Location
            </Form.Label>
            <CommonDropdown key={`location-${typeValue}`} apiUrl={`${apiUrl}get_locations`} placeholder="Select" value={address} onSelect={setAddress} searchView={true} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
              Status
            </Form.Label>
            <CommonDropdown key={`status-${typeValue}`} apiUrl={`${apiUrl}trips/status`} placeholder="Select" value={status} onSelect={setStatus} searchView={true} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
              Date Range
            </Form.Label>
            <DateRangePicker key={`daterange-${typeValue}`} startDate={customizedDateRange.start} endDate={customizedDateRange.end} onChange={handleCustomizedDateChange} style={{ height: "38px", border: "1px solid #ccc" }} />
          </Form.Group>
        </Col>
      </>
    );

    if (typeValue === "trip") {
      filters = (
        <>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Vendor
              </Form.Label>
              <CommonDropdown key={`vendor-${typeValue}`} apiUrl={`${apiUrl}vendor/autosuggestion`} placeholder="Select" value={customer} onSelect={setCustomer} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Vehicle
              </Form.Label>
              <CommonDropdown key={`vehicle-${typeValue}`} apiUrl={`${apiUrl}vehicle/autosuggestion`} placeholder="Select" value={vehicle} onSelect={setVehicle} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Milestone
              </Form.Label>
              <CommonDropdown key={`milestone-${typeValue}`} apiUrl={`${apiUrl}milestone/autosuggestion`} placeholder="Select" value={milestone} onSelect={setMilestone} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Status
              </Form.Label>
              <CommonDropdown key={`status-${typeValue}`} apiUrl={`${apiUrl}trips/status`} placeholder="Select" value={status} onSelect={setStatus} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Date Range
              </Form.Label>
              <DateRangePicker key={`daterange-${typeValue}`} startDate={customizedDateRange.start} endDate={customizedDateRange.end} onChange={handleCustomizedDateChange} style={{ height: "38px", border: "1px solid #ccc" }} />
            </Form.Group>
          </Col>
        </>
      );
    } else if (typeValue === "stop") {
      filters = (
        <>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Customer
              </Form.Label>
              <CommonDropdown key={`customer-${typeValue}`} apiUrl={`${apiUrl}customer/autosuggestion`} placeholder="Select" value={customer} onSelect={setCustomer} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Stops
              </Form.Label>
              <CommonDropdown key={`stop-${typeValue}`} apiUrl={`${apiUrl}stops/autosuggestion`} placeholder="Select" value={stop} onSelect={setStop} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Product
              </Form.Label>
              <CommonDropdown key={`product-${typeValue}`} apiUrl={`${apiUrl}item/autosuggestion`} placeholder="Select" value={product} onSelect={setProduct} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Address
              </Form.Label>
              <CommonDropdown key={`address-${typeValue}`} apiUrl={`${apiUrl}location`} placeholder="Select" value={address} onSelect={setAddress} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Status
              </Form.Label>
              <CommonDropdown key={`status-${typeValue}`} apiUrl={`${apiUrl}trips/status`} placeholder="Select" value={status} onSelect={setStatus} searchView={true} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                Date Range
              </Form.Label>
              <DateRangePicker key={`daterange-${typeValue}`} startDate={customizedDateRange.start} endDate={customizedDateRange.end} onChange={handleCustomizedDateChange} style={{ height: "38px", border: "1px solid #ccc" }} />
            </Form.Group>
          </Col>
        </>
      );
    }

    return filters;
  };

  return (
    <div
      className="d-flex text-start"
      style={{
        backgroundColor: "#f8f9fa",
        minHeight: "fit-content",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <Sidebar currentfile="Reports" />
      <LoaderModal show={loading} />

      <div
        className="p-4"
        style={{
          width: "calc(100vw - 80px)",
          overflowY: "auto",
          height: "100vh",
        }}
      >
        {/* Top Header Area */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          {/* Tabs */}
          <div className="bg-white p-1 rounded-pill shadow-sm d-inline-flex">
            <Button
              variant={activeTab === "Customized" ? "primary" : "light"}
              className={`rounded-pill fw-500 px-4 ${activeTab === "Customized" ? "" : "bg-white text-muted border-0"}`}
              style={{
                backgroundColor: activeTab === "Customized" ? "#3469E7" : "transparent",
                borderColor: activeTab === "Customized" ? "#3469E7" : "transparent",
                fontSize: "14px",
                paddingTop: "8px",
                paddingBottom: "8px",
              }}
              onClick={() => setActiveTab("Customized")}
            >
              Customized
            </Button>
            <Button
              variant={activeTab === "Quick Report" ? "primary" : "light"}
              className={`rounded-pill fw-500 px-4 ${activeTab === "Quick Report" ? "" : "bg-white text-muted border-0"}`}
              style={{
                backgroundColor: activeTab === "Quick Report" ? "#3469E7" : "transparent",
                borderColor: activeTab === "Quick Report" ? "#3469E7" : "transparent",
                fontSize: "14px",
                paddingTop: "8px",
                paddingBottom: "8px",
              }}
              onClick={() => setActiveTab("Quick Report")}
            >
              Quick Report
            </Button>
          </div>

          {/* Right Actions */}
          <div className="d-flex gap-3">
            <Dropdown>
              <Dropdown.Toggle variant="white" className="bg-white border rounded-pill px-3 py-2 d-flex align-items-center gap-2 text-primary fw-500 fs-14 shadow-sm">
                <FiLayout size={16} />
                My templates
                <FiChevronDown size={16} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {templates.map((t) => (
                  <Dropdown.Item key={t.value} onClick={() => handleTemplateSelect(t.value)}>
                    {t.label}
                  </Dropdown.Item>
                ))}
                {templates.length === 0 && <Dropdown.Item disabled>No templates found</Dropdown.Item>}
              </Dropdown.Menu>
            </Dropdown>

            {/* <Button
              variant="white"
              className="bg-white border rounded-pill px-3 py-2 d-flex align-items-center gap-2 text-primary fw-500 fs-14 shadow-sm"
            >
              <BsClockHistory size={16} />
              Previous exports
              <FiChevronDown size={16} />
            </Button> */}
          </div>
        </div>

        {/* Main Content Card */}
        <Card className="border-0 shadow-sm rounded-4 overflow-hidden" style={{ minHeight: "600px" }}>
          <Row className="g-0 h-100">
            {/* Left Sidebar Info */}
            <Col
              md={3}
              className="p-4"
              style={{
                backgroundColor: "#F8F9FE",
                borderRight: "1px solid #eee",
              }}
            >
              <div className="h-100 d-flex flex-column">
                <h5 className="fw-bold mb-3" style={{ color: "#1a1a1a" }}>
                  Generate report
                </h5>
                <p className="text-muted fs-14 lh-base mb-5">Generate report with your specified filters. So you can see and manage that specified data which you want.</p>

                {/* Illustration Placeholder */}
                <div className="mt-auto d-flex justify-content-center">
                  <img src={report} alt="Report Illustration" className="img-fluid" />
                </div>
              </div>
            </Col>

            {/* Right Form Area */}
            <Col md={9} className="p-5 bg-white">
              {activeTab === "Customized" ? (
                <Form>
                  <Row className="g-4 mb-4">
                    <Col md={3}>
                      <div className="fw-bold fs-13 mb-2" style={{ color: "#28303F" }}>
                        Type
                      </div>
                      <CommonDropdown apiUrl={`${apiUrl}get_report_type`} placeholder="Select" value={type} onSelect={setType} searchView={true} />
                      {/* </Form.Group> */}
                    </Col>
                    {renderFilters()}
                  </Row>

                  {/* Footer Actions */}
                  <div className="d-flex justify-content-between align-items-center mt-5 pt-5">
                    <Button variant="outline-none" className="rounded-pill px-4 py-2 fw-500 fs-14 d-flex align-items-center gap-2" style={{ borderColor: "#3469E7", color: "#3469E7" }} onClick={() => setShowSaveModal(true)}>
                      <FiDownload size={16} />
                      Save as template
                    </Button>

                    <div className="d-flex gap-3">
                      <Button variant="white" className="rounded-pill px-4 py-2 fw-500 fs-14 border" style={{ color: "#28303F" }} onClick={handleReset}>
                        Reset
                      </Button>
                      <Button
                        variant="primary"
                        className="rounded-pill px-5 py-2 fw-500 fs-14"
                        style={{
                          backgroundColor: "#3469E7",
                          borderColor: "#3469E7",
                        }}
                        onClick={handleExport}
                      >
                        Export
                      </Button>
                    </div>
                  </div>
                </Form>
              ) : (
                <div className="fade-in">
                  <div className="text-center mb-4 position-relative">
                    <div
                      style={{
                        borderTop: "1px dashed #e0e0e0",
                        position: "absolute",
                        top: "50%",
                        width: "100%",
                        zIndex: 0,
                      }}
                    ></div>
                    <span className="bg-white px-3 position-relative fw-bold text-dark" style={{ zIndex: 1, color: "#28303F" }}>
                      Just a single click is enough!
                    </span>
                  </div>
                  <Row>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                        flexWrap: "wrap",
                        gap: "12px",
                        marginBottom: "16px",
                      }}
                    >
                      {/* Date Range */}
                      <div
                        className="d-flex align-items-center px-2"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          height: 38,
                          backgroundColor: "white",
                        }}
                      >
                        <FiCalendar size={16} className="text-muted me-2" />
                        <DateRangePicker startDate={quickDateRange.start} endDate={quickDateRange.end} onChange={handleQuickDateChange} style={{ border: "none", outline: "none" }} />
                      </div>

                      {/* Clear Button */}
                      {(quickDateRange.start || quickDateRange.end) && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="d-flex align-items-center gap-2"
                          style={{
                            height: 38,
                            borderRadius: "12px",
                            fontSize: "13px",
                            fontWeight: 500,
                          }}
                          onClick={() => setQuickDateRange({ start: null, end: null })}
                        >
                          <FiXCircle size={16} />
                        </Button>
                      )}
                    </div>
                  </Row>
                  <Row className="g-3">
                    {quickReportList.map((report, index) => (
                      <Col md={3} key={index}>
                        <div
                          className="p-2 rounded-3 d-flex border align-items-center gap-3 shadow-sm h-100"
                          style={{
                            cursor: loadingReportId === report.value ? "not-allowed" : "pointer",
                            transition: "all 0.2s",
                            minHeight: "48px",
                            backgroundColor: "#F8F8F8",
                            border: "none",
                            opacity: loadingReportId === report.value ? 0.6 : 1,
                            position: "relative",
                          }}
                          onClick={() => loadingReportId === null && exportQuickGet(report)}
                        >
                          {loadingReportId === report.value ? (
                            <>
                              <div className="spinner-border spinner-border-sm text-primary" role="status" style={{ width: "20px", height: "20px" }}>
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <span className="fw-500 fs-13 text-dark">Loading...</span>
                            </>
                          ) : (
                            <>
                              <div className="text-primary d-flex align-items-center justify-content-center" style={{ width: "24px" }}>
                                {getIconForReport(report.label)}
                              </div>
                              <span className="fw-500 fs-13 text-dark">{report.label}</span>
                            </>
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              )}
            </Col>
          </Row>
        </Card>
      </div>

      {/* Save Template Modal */}
      <Modal show={showSaveModal} onHide={() => setShowSaveModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Save Template</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Template Name</Form.Label>
            <Form.Control type="text" placeholder="Enter template name" value={templateName} onChange={(e) => setTemplateName(e.target.value)} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSaveModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveTemplate}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Toast Container */}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast onClose={() => setToast({ ...toast, show: false })} show={toast.show} delay={3000} autohide bg={toast.variant}>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Report;
